import dayjs from 'dayjs';
import { Variants } from 'framer-motion';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import Button from '~components/Button';
import ButtonClose from '~components/ButtonClose';
import useMedia from '~hooks/useMedia';
import colors from '~lib/styles/Theme/colors';
import { isClient } from '~utils/lodash/isServer';

import { S } from './style';

function SalaryRankingNudge() {
  const router = useRouter();
  const { isMobile } = useMedia();
  const [isActive, setIsActive] = useState(false);
  const salaryReportNudge = isClient ? localStorage.getItem('salaryReportNudge') : null;

  useEffect(() => {
    if (salaryReportNudge) {
      const now = dayjs();
      const nudgeExpired = JSON.parse(salaryReportNudge);
      if (now.diff(nudgeExpired, 'day') <= 0) {
        setIsActive(false);
      } else {
        localStorage.removeItem('salaryReportNudge');
      }
    } else {
      setIsActive(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem('salaryReportNudge', JSON.stringify(dayjs().add(7, 'day')));
    setIsActive(false);
  };

  const mobileVariants: Variants = {
    initial: { opacity: 0, willChange: 'opacity' },
    animate: {
      opacity: 1,
      transition: { duration: 0.8 },
      willChange: 'opacity, transition',
    },
  };
  const desktopVariants: Variants = {
    initial: { opacity: 0, x: '100vw', willChange: 'opacity, transition' },
    animate: {
      opacity: 1,
      x: 'calc(100vw - (100% + 40px))',
      transition: { duration: 0.8, delay: 1.5 },
      willChange: 'opacity, transition',
    },
  };

  if (!isActive) {
    return null;
  }

  return (
    <S.Container
      variants={isMobile ? mobileVariants : desktopVariants}
      initial='initial'
      animate='animate'>
      <S.Wrapper>
        {!isMobile && (
          <S.IconWrapper onClick={handleClose}>
            <ButtonClose size={11} color={colors.magenta900} />
          </S.IconWrapper>
        )}
        <>
          <S.ImgWrapper>
            <picture>
              <source
                srcSet='https://image.wanted.co.kr/kreditjob/www/img-home-nudge-chart-m@2x.png 2x'
                media='(max-width: 767px)'
              />
              <source srcSet='https://image.wanted.co.kr/kreditjob/www/img-home-nudge-chart@2x.png 2x' />
              <img src='https://image.wanted.co.kr/kreditjob/www/img-home-nudge-chart.png' alt='' />
            </picture>
          </S.ImgWrapper>
          <S.Text typography={isMobile ? 'midium120_B3' : 'midium150_B1'}>
            연봉, 잘 받고 있는 걸까?
          </S.Text>
          <S.ButtonWrapper>
            <Button
              size={isMobile ? 'sm' : 'lg'}
              variant='magenta'
              as='a'
              data-attribute-id='salaryRank__modal__click'
              onClick={() => {
                router.push('/salaryreport/step');
              }}>
              랭킹보기
            </Button>
          </S.ButtonWrapper>
        </>
      </S.Wrapper>
    </S.Container>
  );
}

export default SalaryRankingNudge;
